




import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({ name: 'textarea-field' })
export default class TextAreaFieldComponent extends Vue {
  @Prop() public value!: string;
  @Prop() public name!: string;
  @Prop({ default: 5 }) public rows!: number;

  public get innerValue() { return this.value; }
  public set innerValue(val: string) {
    this.$emit('input', val);
  }
}
